import { useEffect } from "react";

const BASE = "Рублокс";

/**
 * Ставит <title> вкладки. Передай суффикс страницы — он добавится к бренду.
 * Без аргумента — просто бренд (для главной).
 */
export default function usePageTitle(suffix) {
  useEffect(() => {
    document.title = suffix ? `${suffix} — ${BASE}` : `${BASE} — играй и создавай игры`;
  }, [suffix]);
}
